import React, { useState, useEffect } from 'react'
import Header from './../users/Header'
import NavHeader from './../users/NavHeader'
import { RxRocket } from 'react-icons/rx';
import { MdOutlinePlaylistAdd } from 'react-icons/md';
import NavMenu from './NavMenu';
import { UserAuth } from '../../context/AuthContext'

const Menu = () => {

    const { user, addAirdrop } = UserAuth();
    const uname = user.displayName;

    const [error, setError] = useState('');
    const [loading, setLoading] = useState();
    const [showNotification, setShowNotification] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);


    const [nameProject, setNameProject] = useState('');
    const [chain, setChain] = useState('');
    const [link, setLink] = useState('');
    const [note, setNote] = useState('');
    const isValid = /^[a-zA-Z0-9]+$/.test(nameProject);

    const formData = [
        { id: 1, name: 'nameProject', title: '*Nama Projek / Airdrop (Harus diisi)', desc: 'Masukkan nama projek / airdrop' },
        { id: 2, name: 'chain', title: 'Chain atau Jaringan', desc: 'Contoh: ETH, BSC, Polygon, SOL, dll...' },
        { id: 3, name: 'link', title: 'Link Projek / Airdrop', desc: 'Link website / twitter / telegram' },
        { id: 4, name: 'note', title: 'Catatan', desc: 'Masukan catatan untuk projek ini' },
    ];

    const setHandleInput = (id, e) => {
        if (id === 1) {
            setNameProject(e.target.value);
        } else if (id === 2) {
            setChain(e.target.value);
        } else if (id === 3) {
            setLink(e.target.value);
        } else if (id === 4) {
            setNote(e.target.value);
        }
    };


    /* Render Form */
    const formElement = formData.map((hasil, i) =>
        <label className="block" key={i}>
            <span className="text-zinc-700 text-sm font-medium">{hasil.title}</span>
            <input
                onChange={(e) => setHandleInput(hasil.id, e)}
                type="text"
                className="text-zinc-900 text-sm mt-0 block w-full pl-2 pr-1 px-1 border-0 border-b border-black focus:ring-0 focus:border-primary"
                autoComplete="off"
                placeholder={hasil.desc}
            />
        </label>
    );

    // Add a condition to check if all input values are provided before submitting the form
    const handleAdd = async (e) => {
        e.preventDefault();
        setShowNotification(false);
        setLoading(true);
        try {
            const maxLength = 96;
            if (
                nameProject?.length >= maxLength &&
                chain?.length >= maxLength &&
                link?.length >= maxLength &&
                note?.length >= maxLength
            ) {
                throw new Error('Input value tidak boleh lebih dari 96 karakter');
            }
            if (!nameProject) {
                throw new Error('Nama Projek / Airdrop harus diisi');
            }
            if (nameProject.length < 3) {
                throw new Error('Nama Project / Airdrop minimal terdiri dari 3 karakter');
            }
            if (!isValid) {
                throw new Error('Nama Projek / Airdrop hanya boleh terdiri dari angka atau huruf');
            }
            const result = await addAirdrop(
                uname,
                nameProject, chain,
                link, note
            )
            if (result === true) {
                setShowNotification(true);
                setError('Berhasil disimpan');
            } else {
                throw new Error(result)
            }

        } catch (e) {
            setShowNotification(true);
            setError(e.message);
        } finally {
            setLoading(false);
            setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
        }
    };

    return (
        <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
            <NavHeader />
            <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
                <Header />
                {loading && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
                        <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
                    </div>
                )}
                {showNotification && (
                    <div className="px-4 fixed bottom-[50px] w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
                        <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                            {error}
                            <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
                        </div>
                    </div>
                )}
                <div className='pt-3 pb-[96px]'>
                    <div className='bg-white'>
                        <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center'>
                            <div className='flex items-center'>
                                <span className="mr-2">
                                    <RxRocket className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                                </span>
                                <h1 className='font-semibold text-base md:text-lg'>Garap Airdrop</h1>
                            </div>
                            <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                                Pelajari
                            </div>
                        </div>
                        <NavMenu />
                        <div className="bottom-0 bg-slate-100 h-[4px] z-10 -mt-1"></div>
                        <div className=''>
                            <div className='flex justify-between items-center'>
                                <div className='flex items-center p-4'>
                                    <span className='mr-2'>
                                        <MdOutlinePlaylistAdd size='20' />
                                    </span>
                                    <h1 className='font-semibold text-base'>Add Airdrop</h1>
                                </div>
                            </div>
                            <div className='px-4'>
                                <form onSubmit={handleAdd}>
                                    <div className="grid grid-cols-1 gap-4">
                                        {formElement}
                                    </div>
                                    <div className='max-w-[600px] mx-auto bottom-0 fixed left-0 right-0 border-t bg-white p-4'>
                                        <button className="w-full py-2 rounded-md font-semibold text-white bg-primary flex flex-row justify-center items-center hover:bg-secondary focus:outline-none focus:bg-secondary" type="submit">Add Airdrop</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Menu
